import React, { useEffect, useState } from "react";
import "./index.scss";
import { Button, Icon, Illustration, Text } from "@mbank-design/design-system/components";
import { CarHighwayMass } from "@mbank-design/design-system/illustrations";
import { FontWeight, LineHeight } from "@mbank-design/design-system/design-tokens/general/typography";
import { Cross } from "@mbank-design/design-system/icons";
import { FontColor, IconColor, IconSize } from "@mbank-design/design-system/enums";

import moment from "moment";
import { useLocation } from "react-router-dom";

const VISIT_POPUP_DAY_KEY = "visitPopupShownDate";

const SITES_WITHOUT_POPUP = [
  "/lp-q7",
  "/lp-afi",
  "/lp-tesla-3",
  "/lp-tesla-y",
  "/lp-hyundai",
  "/lp-bmw",
  "/targi",
  "/konkurs",
  "/lp-taniej-z-mauto",
  "/lp-2000-na-paliwo",
  "/lp-taniej-z-mBankiem",
  "/lp-aio",
  "/lp-4500zl-na-auto",
];

const VisitPopup = () => {
  const location = useLocation();
  const [showVisitPopup, setShowVisitPopup] = useState<boolean>(false);

  useEffect(() => {
    const path = location.pathname.toLowerCase();
    if (SITES_WITHOUT_POPUP.includes(path)) {
      return;
    }

    const tryShowOnMouseLeaveViewport = () => {
      const today = moment().format("YYYY-MM-DD");
      if (localStorage.getItem(VISIT_POPUP_DAY_KEY) === today) {
        return;
      }
      setShowVisitPopup(true);
      localStorage.setItem(VISIT_POPUP_DAY_KEY, today);
    };

    const html = document.documentElement;
    html.addEventListener("mouseleave", tryShowOnMouseLeaveViewport);
    return () => html.removeEventListener("mouseleave", tryShowOnMouseLeaveViewport);
  }, [location.pathname]);

  return (
    <>
      {showVisitPopup && (
        <div className="exit-popup-container">
          <div className="exit-popup">
            <div className="exit-popup__close-button" onClick={() => setShowVisitPopup(false)} role="button" tabIndex={0} aria-label="Zamknij">
              <Icon primaryColor={IconColor.DARK} size={IconSize.NORMAL} iconComponent={Cross} />
            </div>
            <div className="exit-popup__illustration-container">
              {/* <Illustration illustrationComponent={CarHighwayMass} size={360} /> */}
            </div>
            <div className="exit-popup__text-container">
              <Text as="h1" marginBottom={26} lineHeight={LineHeight.HEIGHT_48} color={FontColor.DARK}>
                zyskaj raz... <br />  a potrójnie!
              </Text>
              <Text as="p" marginBottom={26} lineHeight={LineHeight.HEIGHT_32} color={FontColor.DARK} fontFamily={'mBank'}>zgarnij do <strong style={{ color: "red" }}>4 500 zł</strong><br/> dla klientów mBanku<br/>na auto dla firmy</Text>
              <a href={"/lp-4500zl-na-auto"} role="button" tabIndex={0} aria-label="Zostaw kontakt">
                <Button buttonType="primary" size="normal">
                  poznaj szczegóły
                </Button>
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default VisitPopup;
